/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, DateField, FieldProps, TextField } from 'framework/ui/field';
import ContractInfinitySymbol from './ContractInfinitySymbol';

interface ContractEndDateBadgeFieldProps extends FieldProps {}

const ContractEndDateBadgeField = (props: ContractEndDateBadgeFieldProps) => {
  const { getValue: getIsIndefiniteValue } = useFieldHelper({ source: 'isIndefinite' });
  const indefinite = getIsIndefiniteValue();

  return indefinite ? <TextField value={<ContractInfinitySymbol />} /> : <DateField {...props} />;
};

export default ContractEndDateBadgeField;
